export enum PlatformAddOn {
  Website = 1,
  JobBoard = 2,
  BillingAndProposals = 3,
  BookingAndScheduling = 4,
  Forms = 5,
}